<div class="dropdown">
  <div class="container">
    <app-scrollbar
      #scrollbar
      class="scrollbar"
      [vertical]="true"
      [size]="'standard'"
      [theme]="'light'"
      [visibility]="'native'">
      @for (page of pages; track page) {
        <div class="page" [class.current]="page === activePage" (click)="selectPage(page)">
          {{ page }}
        </div>
      }
    </app-scrollbar>
  </div>
</div>
